import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController, LoadingController, IonicModule } from '@ionic/angular';
import { AjaxBridgeProvider } from '../../providers/ajax-bridge/ajax-bridge';
import {Collection} from '../../bayadic-shared-models/collection/Collection';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'page-modal-description',
  templateUrl: 'modal-description.html',
  styleUrls: ['modal-description.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule]

})
export class ModalDescriptionPage {

  public chat : Chat;
  public title;
  public collection : Collection;
  public description;
  constructor( 
       
      private view: ModalController,
      public loadingCtrl: LoadingController, 
      public ajaxBridge: AjaxBridgeProvider) {
      // this.chat = navParams.get("chat");
      // this.collection = navParams.get("collection");
//      this.title = this.chat.title;
      this.loadDescription();
      this.presentLoadingDefault();
  }
  closeModal(){
      this.view.dismiss();
  }
  strip(html: string) {
	return html.replace(/<(?:.|\n)*?>/gm, '');
    }
  presentLoadingDefault() {

    }
  getDescription(lang){
//      let description = "";
      return this.collection.getDescription();
//      switch (this.collection.lang){
//      case "de":
//        
//      case "fa":
//      case "en":
//      break;
//      };
//      return description;
  }
  loadDescription(){
      var self = this;
//      this.ajaxBridge.queryPro("getProductDescription", this.chat.id).then(data=> {
//          self.description = this.strip(data[0]['description_short']);
//      });
  }
  ionViewDidLoad() {

//    this.logger.debug('ionViewDidLoad ModalDescriptionPage');
//    this.logger.debug("sdf", this.navParams.get('userId'));
  }

}
